import '../../../../commom/Base64';
import { User, tApi } from 'tplus-api';

/**
 * 弹出超出最低零售价
 */
export class ControlReturnProcessorBlock {
  static async execute(content, popupMethod, params) {
    let confirm=popupMethod.confirm;
    let forbidden=popupMethod.forbidden;
    let pwdAuth=popupMethod.pwdAuth;
    let otherAuth=popupMethod.otherAuth;
    let callObj= popupMethod.callObj;
    var returnResult = true;
    let columns = new Array();
    let dataSource = new Array();
    let result = null;
    content = "请管理员输入账号和密码！";
      // 校验密码
    let check = async (form) => {
      $T.debugger();
      let authPwd = User.pwdEncrypt(form.authPwd);
      let authUserName = form.authUserName;
      var content = {};
      content.userName = authUserName;
      content.passowrd = authPwd;
      content.authName='ReverseOperation'
      let result = await tApi({'content': JSON.stringify(content)}, 'chanjet.RE.INewPos.CheckUserAuth', false, false);
      console.log("CheckUserLowestDiscount返回结果:" + result);
      return result;
    };
    $T.debugger();
    result = await otherAuth.call(callObj, { content, check, columns, dataSource });
    $T.debugger();
    if (result) {
      returnResult = true;
    }
    else {
      returnResult = false;
    }
    return returnResult;
  }
}